var _mask, _path, _path2, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSignup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 160,
    viewBox: "0 0 312 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5326_1958",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 37C114 34.7909 115.791 33 118 33H195C197.209 33 199 34.7909 199 37V160H114V37Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 37C114 34.7909 115.791 33 118 33H195C197.209 33 199 34.7909 199 37V160H114V37Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113 37C113 34.2386 115.239 32 118 32H195C197.761 32 200 34.2386 200 37H198C198 35.3431 196.657 34 195 34H118C116.343 34 115 35.3431 115 37H113ZM199 160H114H199ZM113 160V37C113 34.2386 115.239 32 118 32V34C116.343 34 115 35.3431 115 37V160H113ZM195 32C197.761 32 200 34.2386 200 37V160H198V37C198 35.3431 196.657 34 195 34V32Z",
    fill: "#909090",
    mask: "url(#path-1-inside-1_5326_1958)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5326_1958)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174 97.8982C174 96.6561 173.889 95.4653 173.686 94.3184H157.346V101.088H166.68C166.279 103.274 165.055 105.129 163.219 106.368V110.758H168.826C172.106 107.713 173.998 103.225 173.998 97.8957L174 97.8982Z",
    fill: "#4377BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.346 115.001C162.029 115.001 165.957 113.434 168.826 110.762L163.219 106.372C161.666 107.422 159.678 108.044 157.346 108.044C152.827 108.044 149.003 104.964 147.639 100.828H141.846V105.362C144.7 111.082 150.566 115.003 157.348 115.003L157.346 115.001Z",
    fill: "#36A052"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.641 100.825C147.295 99.7753 147.097 98.6528 147.097 97.4986C147.097 96.3444 147.293 95.2243 147.641 94.1726V89.6387H141.846C140.67 92.0032 140 94.6753 140 97.4986C140 100.322 140.67 102.994 141.846 105.359L147.641 100.825Z",
    fill: "#EFB619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.346 86.9595C159.893 86.9595 162.179 87.8429 163.976 89.5754L168.952 84.5559C165.95 81.735 162.022 80 157.346 80C150.566 80 144.7 83.9214 141.846 89.6413L147.641 94.1752C149.006 90.039 152.83 86.9595 157.348 86.9595H157.346Z",
    fill: "#DA4234"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 39.5,
    r: 2,
    fill: "white",
    stroke: "#909090"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5326_1958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white",
    transform: "translate(140 80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignup2);
export default __webpack_public_path__ + "static/media/ic-signup-2.cd7f0362bbe967e07d0ee5d03630327d.svg";
export { ForwardRef as ReactComponent };